import React from 'react'

const WorkerRespondToSos = () => {
  return (
    <div>WorkerRespondToSos</div>
  )
}

export default WorkerRespondToSos